import { ApplicationState } from '../store';
import { getContentByKey } from '../services/appservice';
import * as AppDataContainer from '../store/AppDataContainer';
import Cookies from 'universal-cookie';

export class DataManager {    
    appState: ApplicationState;
    cookies = new Cookies();
    decode = require('decode-html');

    constructor(appState: ApplicationState) {
        this.appState = appState;
    }

    loadDataSources = (resourceAPIConfigurations: any, callback: any, requestData?: any, useDefaultParams: boolean = true, successHandlerScript: string = "") => {
        resourceAPIConfigurations.forEach((resourceapiconfiguration: any, index: Number) => {
            var requestParams = this.buildRequestParams(resourceapiconfiguration.RequestMap, requestData, useDefaultParams);
            var isdataloading = resourceAPIConfigurations.length - 1 === index;
            getContentByKey(resourceapiconfiguration.ResourceLocator, requestParams, callback, resourceapiconfiguration.Key, resourceapiconfiguration.ItemPath, !isdataloading, resourceapiconfiguration.HttpMethod, successHandlerScript);
        });
    } 

    loadInitialDataSources = (resourceAPIConfigurations: any, callback: any, requestData?: any, useDefaultParams: boolean = true) => {
        resourceAPIConfigurations.forEach((resourceapiconfiguration: any, index: Number) => {
            if (!resourceapiconfiguration.NotDefaultLoaded) {
                var requestParams = this.buildRequestParams(resourceapiconfiguration.RequestMap, requestData, useDefaultParams);
                var isdataloading = resourceAPIConfigurations.length - 1 === index;
                if (resourceapiconfiguration.Script && resourceapiconfiguration.Script.trim() !== "") {
                    var funExpression = eval("(dataSource,loadDataSources,callback) => {" + this.decode(resourceapiconfiguration.Script) + "}");
                    funExpression(resourceapiconfiguration, this.loadDataSources, callback);
                }
                else {
                    getContentByKey(resourceapiconfiguration.ResourceLocator, requestParams, callback, resourceapiconfiguration.Key, resourceapiconfiguration.ItemPath, !isdataloading, resourceapiconfiguration.HttpMethod);
                }
            }           
        });
    } 

    buildRequestParams = (xpRequestMapping: any, requestData?: any, useDefaultParams: boolean = true) => {
        var requestParams: AppDataContainer.KeyValue = {};
        xpRequestMapping.forEach((mapping:any) => {
            switch (mapping.DataType) {
                case "Array":
                    var strArrayValue = this.getRequestParameter(mapping, requestData, useDefaultParams);
                    if (!strArrayValue) break;
                    if (strArrayValue.indexOf(",") > -1) {
                        requestParams[mapping.RequestParamName] = strArrayValue.split(",");
                    }
                    else if (Array.isArray(strArrayValue)) {
                        requestParams[mapping.RequestParamName] = strArrayValue;
                    }
                    else {
                        requestParams[mapping.RequestParamName] = [strArrayValue];
                    }
                    break;
                case "JSON":
                    if (mapping.InnerRequestMap && mapping.InnerRequestMap.length > 0) {
                        requestParams[mapping.RequestParamName] = this.buildRequestParams(mapping.InnerRequestMap, requestData, useDefaultParams);
                    }
                    else if (mapping.SubInnerRequestMap && mapping.SubInnerRequestMap.length > 0) {
                        requestParams[mapping.RequestParamName] = this.buildRequestParams(mapping.SubInnerRequestMap, requestData, useDefaultParams);
                    }
                    else {
                        requestParams[mapping.RequestParamName] = JSON.parse(mapping.DefaultValue);
                    }
                    break;
                case "JSONArray":
                    if (mapping.InnerRequestMap && mapping.InnerRequestMap.length > 0) {
                        requestParams[mapping.RequestParamName] = [this.buildRequestParams(mapping.InnerRequestMap, requestData, useDefaultParams)];
                    }
                    else if (mapping.SubInnerRequestMap && mapping.SubInnerRequestMap.length > 0) {
                        if (requestParams[mapping.RequestParamName]) {
                            requestParams[mapping.RequestParamName].push(this.buildRequestParams(mapping.SubInnerRequestMap, requestData, useDefaultParams));
                        }
                        else {
                            requestParams[mapping.RequestParamName] = [this.buildRequestParams(mapping.SubInnerRequestMap, requestData, useDefaultParams)];
                        }

                    }
                    else {
                        requestParams[mapping.RequestParamName] = JSON.parse(mapping.DefaultValue);
                    }
                    break;
                case "String":
                    let strParam = this.getRequestParameter(mapping, requestData, useDefaultParams);
                    if (!strParam) break;
                    requestParams[mapping.RequestParamName] = strParam;//this.getRequestParameter(mapping, requestData, useDefaultParams);
                    break;                
                default:
                    let defaultParam = this.getRequestParameter(mapping, requestData, useDefaultParams);
                    if (!defaultParam) break;
                    requestParams[mapping.RequestParamName] = defaultParam;//this.getRequestParameter(mapping, requestData, useDefaultParams);
                    break;
            }
        });
        return requestParams;
    }

    getRequestParameter = (mapping: any, requestData?: any, useDefaultParams: boolean = true) => {
        mapping.DefaultValue = (mapping.DefaultValue ? mapping.DefaultValue : mapping.DefValue);
        switch (mapping.SourceOfClientParam) {
            case "QueryString":
                if (requestData && requestData.hasOwnProperty(mapping.RequestParamName) && requestData[mapping.RequestParamName] && requestData[mapping.RequestParamName] !== "") {
                    return requestData[mapping.RequestParamName];
                }
                if (!useDefaultParams) {
                    return null;
                }
                var param = this.getQueryString(mapping.ClientParamName);
                return param ? param : mapping.DefaultValue;
            case "Route":
                var routeUrl = this.appState && this.appState.appStore && this.appState.appStore.RouteUrl ? this.appState.appStore.RouteUrl : "";
                switch (mapping.DefaultValue) {
                    case "Route[0]":
                        return routeUrl.split("/")[0].toLowerCase();
                    case "Route[1]":
                        return routeUrl.split("/")[1].toLowerCase();
                }
                return routeUrl ? routeUrl.replace("/", "_").toLowerCase() : mapping.DefaultValue;
            case "Cookie":
                var cookieValue = this.cookies.get(mapping.RequestParamName);
                return cookieValue;
            default:
                switch (mapping.DataType) {
                    case "Number":
                        if (requestData && requestData.hasOwnProperty(mapping.RequestParamName)) {
                            return parseInt(requestData[mapping.RequestParamName]);
                        }
                        if (!useDefaultParams) {
                            return null;
                        }
                        return parseInt(mapping.DefaultValue);
                    case "Bool":
                        if (requestData && requestData.hasOwnProperty(mapping.RequestParamName)) {
                            return requestData[mapping.RequestParamName];
                        }
                        if (!useDefaultParams) {
                            return null;
                        }
                        return mapping.DefaultValue.toLowerCase() === "true";
                }
                if (requestData && requestData.hasOwnProperty(mapping.RequestParamName)) {
                    return requestData[mapping.RequestParamName];
                }
                if (!useDefaultParams) {
                    return null;
                }
                return mapping.DefaultValue;
        }
    }

    getMicroContentString = (datasourcekey: string, itemkey: string) => {
        if (this.appState && this.appState.appStore && this.appState.appStore.MicroContentString &&
            this.appState.appStore.MicroContentString.hasOwnProperty(datasourcekey)) {
            let microcontentList = this.appState.appStore.MicroContentString[datasourcekey];
            var filteredList = microcontentList.filter(function (item : any) {
                return item.Key === itemkey;
            });
            if (filteredList && filteredList.length > 0) {
                return filteredList[0].DynamicProperties.MicroContentValue;
            }
            else {
                return "Invalid Microcontentstring with key : " + itemkey + " in datasource : " + datasourcekey;
            }
        }
        else {
            return " Microcontentstring with key : " + itemkey + "not found in datasource : " + datasourcekey;
        }
    }

    getMicroContentLink = (datasourcekey: string, databoundProperty: string, itemkey: string) => {
        if (this.appState && this.appState.appStore && this.appState.appStore.MicroContentLink && this.appState.appStore.MicroContentLink.hasOwnProperty(datasourcekey)) {
            let microcontentList = this.appState.appStore.MicroContentLink[datasourcekey];
            var filteredList = microcontentList.filter(function (item : any) {
                return item.Key === itemkey;
            });
            if (filteredList && filteredList.length > 0) {
                return filteredList[0].DynamicProperties[databoundProperty];
            }
            else {
                return "Invalid Microcontentlink with key : " + itemkey + " in datasource : " + datasourcekey;
            }
        }
        else {
            return " Microcontentlink with key : " + itemkey + "not found in datasource : " + datasourcekey;
        }
    }

    loadDatasourceByKey = (datasourceKey: string, callback: any, requestData: any, useDefaultParams: boolean = true, successHandlerScript: string = "") => {
        let datasource = this.appState.appStore && this.appState.appStore.DataSources ? this.appState.appStore.DataSources.find(d => d.Key === datasourceKey) : null;
        if (datasource) {
            this.loadDataSources([datasource], callback, requestData, useDefaultParams, successHandlerScript);
        }
    }

    getContentByKey = (url: string, request: any, callback: any, key: string, itemPath: string, isdataloading: boolean, apitype:string = "post", successHandlerScript: string = "") => {
        getContentByKey(url, request, callback, key, itemPath, isdataloading, apitype, successHandlerScript);
    }

    getMicroContentImage = (datasourcekey: string, itemkey: string) => {
        if (this.appState && this.appState.appStore && this.appState.appStore.MicroContentImage && this.appState.appStore.MicroContentImage.hasOwnProperty(datasourcekey)) {
            let microcontentList = this.appState.appStore.MicroContentImage[datasourcekey];
            var filteredList = microcontentList.filter(function (item : any) {
                return item.Key === itemkey;
            });
            if (filteredList && filteredList.length > 0) {
                return filteredList[0].DynamicProperties.Image[0].Path;
            }
            else {
                return "Invalid MicrocontentImage with key : " + itemkey + " in datasource : " + datasourcekey;
            }
        }
        else {
            return " MicrocontentImage with key : " + itemkey + "not found in datasource : " + datasourcekey;
        }
    }

    getQueryString = (key: string) => {
        if (this.appState && this.appState.appStore && this.appState.appStore.QueryStringParams && this.appState.appStore.QueryStringParams[key]) {
            return this.appState.appStore.QueryStringParams[key];
        }
        else {
            return null;
        }
    }
}